import React from 'react';
import { config } from '@triare/auth-redux';
import Layout from '../../components/Layout';
import CategoriesContent from '../../components/Pages/Categories';
import CategoriesProvider from '../../components/Pages/Home/HowMuchToTip/CategoryProvider';

const { displayName } = config;

export default function TippingCategories(): React.ReactElement {
  document.title = `${displayName}: Tipping Categories`;

  return (
    <Layout>
      <CategoriesProvider>
        <CategoriesContent />
      </CategoriesProvider>
    </Layout>
  );
}
